


import firebaseApp from './firebaseApp'
import 'firebase/firestore'
import firebase from 'firebase'

const firestore = firebaseApp.firestore();

//firestore.settings(settings);

export default firestore

export function serverTimestanp(){
    return firebase.firestore.FieldValue.serverTimestamp()
} 